import {Selector} from '@ngxs/store';
import {AdvertiserCampaignsState} from './advertiser-campaigns.state';
import {ICampaignActiveScheduled, ICampaignSaved} from '@interfaces/advertiser/campaign';
import {ICampaignHistory} from '@interfaces/campaigns';
import {AdvertiserCampaignsModel} from './advertiser-campaigns.model';

export class AdvertiserCampaignsSelectors {
  @Selector([AdvertiserCampaignsState])
  static getAdvertiserCampaigns(state: AdvertiserCampaignsModel): (ICampaignSaved | ICampaignActiveScheduled | ICampaignHistory)[] {
    return state.campaigns;
  }

  @Selector([AdvertiserCampaignsState])
  static getAdvertiserCampaignsLoader(state: AdvertiserCampaignsModel): boolean {
    return state.loader;
  }
}
